// Renders a Normal Form Input Field with the label to the left

import React from 'react';
import { Input, Label } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const RenderFieldLeft = ({
  onChange,
  value,
  name,
  error,
  label,
  type }) => (
    <div>
      <div style={{ padding: "10px" }}>
        <Input
          fluid
          size='large'
          labelPosition='left'
          type={type}
          value={value}
          onChange={onChange}
          name={name}
          error={error ? true : false}>
          <Label color="blue">{label}</Label>
          <input />
        </Input>
        {error && <div className="ui pointing red basic label">{error}</div>}
      </div>
    </div>
  )

RenderFieldLeft.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  info: PropTypes.string,
  error: PropTypes.string,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.string,
  label: PropTypes.string,
};

RenderFieldLeft.defaultProps = {
  type: 'text'
};

export default RenderFieldLeft;